import { useState } from "react";
import { Send, Loader2, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function AgreementInviteForm({ onCreated }) {
  const [f, setF] = useState({ tech_name: "", tech_email: "", company_signer_name: "David E. Brooks Jr", company_signer_title: "Owner", message: "" });
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/agreements", f, { timeout: 60000 });
      setLast(r.data);
      toast.success(r.data.email_sent ? `Invite emailed to ${r.data.tech_email}` : "Invite created — email didn't go out, copy the link instead");
      setF({ ...f, tech_name: "", tech_email: "", message: "" });
      onCreated?.(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't create the invite");
    } finally { setBusy(false); }
  };

  const inp = "dg-input w-full mt-1 py-1.5 text-sm";
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="agreement-invite-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="text-xs text-slate-400">Technician name<input className={inp} value={f.tech_name} onChange={set("tech_name")} required minLength={2} data-testid="invite-tech-name" /></label>
        <label className="text-xs text-slate-400">Technician email<input className={inp} type="email" value={f.tech_email} onChange={set("tech_email")} required data-testid="invite-tech-email" /></label>
        <label className="text-xs text-slate-400">Your name (signs for Dr.Gadget)<input className={inp} value={f.company_signer_name} onChange={set("company_signer_name")} required data-testid="invite-signer-name" /></label>
        <label className="text-xs text-slate-400">Your title<input className={inp} value={f.company_signer_title} onChange={set("company_signer_title")} data-testid="invite-signer-title" /></label>
      </div>
      <label className="text-xs text-slate-400 block">Personal note (optional)<textarea className={`${inp} min-h-[60px]`} value={f.message} onChange={set("message")} maxLength={1000} placeholder="Great meeting you — here's the agreement we talked about." data-testid="invite-message" /></label>
      <p className="text-[11px] text-amber-200/80">Your typed name is applied as the Company signature the moment you send. Only send once your attorney has reviewed the template and your business terms are saved above.</p>
      <button type="submit" disabled={busy} className="dg-btn-primary rounded-full px-5 py-2 text-sm inline-flex items-center gap-2 disabled:opacity-50" data-testid="invite-send-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send signing link
      </button>
      {last && (
        <div className="text-xs text-slate-300 flex flex-wrap items-center gap-2 rounded-lg border border-slate-700 p-2" data-testid="invite-last-link">
          <span className="font-mono text-cyan-300 break-all">{last.sign_url}</span>
          <button type="button" onClick={() => { navigator.clipboard?.writeText(last.sign_url); toast.success("Link copied"); }} className="dg-link inline-flex items-center gap-1" data-testid="invite-copy-link"><Copy className="w-3 h-3" /> copy</button>
        </div>
      )}
    </form>
  );
}
